const colors = {
  primary: '#FFFFFF', // Pure white
  secondary: '#6200EE', // Darker purple for better contrast on white
  accent: '#018786', // Darker teal for better contrast on white
  background: '#FFFFFF', // White background
  surface: '#F5F5F5', // Light gray surface
  text: '#212121', // Dark text for contrast on white
  lightText: '#757575', // Medium gray text
  white: '#FFFFFF',
  black: '#000000',
  gray: '#EEEEEE',
  lightGray: '#F5F5F5',
  darkGray: '#9E9E9E',
};

export default colors;